

<template>
<div class="login-main">
  <div class="login-info">
    <div class="fs-26 c-main fw-600 flex flex-center">后台管理</div>
    <div class="mt-40">
      <t-form ref="form" :data="formData" :colon="true" :label-width="0" @reset="onReset" @submit="onSubmit">
        <t-form-item name="account">
          <t-input v-model="formData.account" clearable placeholder="请输入账户名">
            <template #prefix-icon>
              <desktop-icon />
            </template>
          </t-input>
        </t-form-item>

        <t-form-item name="password">
          <t-input v-model="formData.password" type="password" clearable placeholder="请输入密码">
            <template #prefix-icon>
              <lock-on-icon />
            </template>
          </t-input>
        </t-form-item>

        <t-form-item>
          <t-button theme="primary" type="submit" block>登录</t-button>
        </t-form-item>
      </t-form>
    </div>
  </div>
</div>
</template>
<script setup>
import {LoginApi} from "@/api/login"
import { reactive } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { DesktopIcon, LockOnIcon } from 'tdesign-icons-vue-next';
import md5 from "md5";

const formData = reactive({
  account: '',
  password: '',
});

const onReset = () => {
  MessagePlugin.success('重置成功');
};

const onSubmit = ({ validateResult, firstError }) => {
  if (validateResult === true) {
    if (formData.account === "") {
      MessagePlugin.warning("账户名不能为空");
      return;
    }
    if (formData.password === "") {
      MessagePlugin.warning("密码不能为空");
      return;
    }

    let param = {
      account: formData.account,
      password: md5(formData.password)
    }
    LoginApi(param).then(res => {
      if (res.data.code == 200) {
        MessagePlugin.success('登录成功');
        localStorage.setItem('api_token', res.data.data.token);
        location.href = '/';
      } else {
        MessagePlugin.warning('登录失败！');
      }
    })
  } else {
    console.log('Validate Errors: ', firstError, validateResult);
    MessagePlugin.warning(firstError);
  }
};
</script>
<style scoped>
.login-main {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;

  background: linear-gradient(
      to right,
      #2775ff 0%,
      #2775ff 50%,
      #ffffff 50%,
      #ffffff 100%
  );
}

  .login-info {
    position: absolute;
    width: 380px;
    height: 340px;
    box-sizing: border-box;
    top: calc(50% - 170px);
    left: calc(50% - 190px);
    cursor: pointer;
    padding:40px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .2);border-color: #eee;
    background-color: #fff;
  }
</style>